import apiClient from "./apiClient";

const get  = (url, params = {})       => apiClient.get(url, { params }).then((r) => r.data);
const post = (url, body) => apiClient.post(url, body).then((r) => r.data);
const put = (url, body) => apiClient.put(url, body).then((r) => r.data);
const patch = (url, body = {}) => apiClient.patch(url, body).then((r) => r.data);
const del = (url) => apiClient.delete(url).then((r) => r.data);

export const fetchLateOrders      = () => get("/live-late-orders");
export const fetchNewOrders       = () => get("/live-new-orders");
export const fetchPreparingOrders = () => get("/live-preparing-orders");
export const fetchAssignedOrders  = () => get("/live-assigned-orders");
export const fetchPickedUpOrders  = () => get("/live-pickedup-orders");
export const fetchCompletedOrders = () => get("/live-completed-orders");
export const fetchAwaitingOrders  = () => get("/live-awaiting-orders");
export const fetchCancelledOrders = () => get("/live-cancelled-orders");
export const fetchAvailableBoys   = () => get("/live-available-boys");
export const fetchDataFeed        = () => get("/live-data-feed-v3");

export const getAnalytics = () => post('/live-data-analytics');

export const fetchOrder = (orderId) =>
    post("/view-order", { order_id: orderId });

export const checkOrderAddressLocation = (orderId, payload) =>
    post(`/order/${orderId}/check-address`, payload);

export const updateOrderDeliveryAddress = (orderId, payload) =>
    post(`/order/${orderId}/update-address`, payload);

export const markArrivedFromAdmin = (orderId) =>
    post(`/order/mark-arrived`, { order_id: orderId });

export const assignDeliveryFromAdmin = (orderId, userId, customerId) =>
    post("/order/assign-delivery-from-admin", { order_id: orderId, user_id: userId, customer_id: customerId });

export const reAssignDeliveryFromAdmin = (orderId, userId, customerId) =>
    post("/order/reassign-delivery", { order_id: orderId, user_id: userId, customer_id: customerId });

export const acceptOrderFromAdmin = (orderId) =>
    post("/order/accept-order", { id: orderId });

export const cancelOrderFromAdmin = (orderId, cancelReason, refundType) =>
    post("/order/cancel-order", { order_id: orderId, cancel_reason: cancelReason, refund_type: refundType });

export const updateOrderFromAdmin = (orderId, request) =>
    post(`/order/update-order/${orderId}`, request);

export const releaseHold = async (id) =>
    await post('/order/release-hold', {order_id: id});

export const payIncentive = async (data) =>
    await post('/shift/generate-incentive-v2', data);


export const apiFetchDeliveryGuyLocation = async (userId) =>
    get(`/delivery-guy-location/${userId}`);


export const apiFetchAvailableDeliveryGuys = async () =>
    get(`/available-delivery-guys`);

export const apiFetchPageOrder = async (params) =>
    get(`/orders?${params}`);


export const apiFetchDeliveryGuys = async ({ search = "", with_inactive, page = 1, limit = 10, zone_id = null, delivery_location_id } = {}) => {
    const params = new URLSearchParams({ page, limit });

    if (search.trim())  params.set("search", search.trim());
    if (zone_id)        params.set("zone_id", zone_id);
    if (with_inactive)  params.set("with_inactive", 1);   // only added when truthy
    if(delivery_location_id) params.set("delivery_location_id", delivery_location_id);

    const res = await get(`/delivery-guys?${params}`);

    return {
        data:    res.data,
        hasMore: res.next_page_url !== null,
        total:   res.total,
    };
};

export const fetchDeliveryPartnerActivity = (user_id) =>
    get(`/delivery-guy/activity/${user_id}`);

export const fetchItemPriceLogs = async (r) => {
    const {
        store_id,
            status,
            q        = "",
            type     = "",
            page     = 1,
            per_page = 10,
    } = r;

    const params = new URLSearchParams({ store_id, status, page, per_page });
    if (q.trim())    params.set("q",    q.trim());
    if (type.trim()) params.set("type", type.trim());

    return post(`/store/item-price-logs?${params}`);
};


export const fetchStores = async ({
                                      q          = "",
                                      page       = 1,
                                      per_page   = 10,
                                      zone_id,
                                      category_id,          // ← add
                                      is_active,
                                      is_accepted,
                                      sort_by    = "created_at",
                                      sort_dir   = "desc",
                                      with_inactive = false,
                                  } = {}) => {
    const params = {
        page,
        per_page,
        sort_by,
        sort_dir,
        ...(q             ? { q }             : {}),
        ...(zone_id       != null ? { zone_id }       : {}),
        ...(category_id   != null ? { category_id }   : {}),   // ← add
        ...(is_active     != null ? { is_active }     : {}),
        ...(is_accepted   != null ? { is_accepted }   : {}),
        ...(with_inactive ? { with_inactive: 1 }      : {}),
    };

    return post("/stores", params);
};


export const fetchOrderReviews = async ({
                                            page = 1,
                                            per_page = 10,
                                            search = "",
                                            rating_type = "all",
                                            rating = "",
                                        } = {}) => {
    const params = new URLSearchParams({ page, per_page });

    if (search.trim()) params.set("search", search.trim());

    if (rating_type && rating_type !== "all") {
        params.set("rating_type", rating_type);
    }

    if (rating !== "") {
        params.set("rating", rating);
    }

    return get(`/order-reviews?${params.toString()}`);
};


export const updateItemPriceLogStatus = (data) =>
    post("/store/item-price-logs/status", data);


export const fetchDeliveryPartnerDetail =  async (user_id) =>
    get(`/delivery-guy/detail/${user_id}`);

export const toggleDeliveryPartnerStatus = (id, forceOffline = false) =>
    post("/delivery-guy/toggle-status", {
        id,
        ...(forceOffline && { force_offline: "true" })
    });

export const deliveryTimeReport = async (start, end) =>
    post(`/delivery-guy/reports`, {start, end})

export const createShift = async (request) =>
    post("/shift/create", request)

export const updateShift = async (id, body) =>
    post(`/shift/update/${id}`, body);

export const getAllShifts = async () => get("/shift/all")

export const deliveryGuysWithStatus = async (shift_id) => post("/shift/delivery-boys-with-status", {shift_id})

export const apiAssignShift = async (body) => post("/shift/assign-shift", body);

export const getShiftReport = async (shiftId, params) => {
    const p = new URLSearchParams();
    if (params.delivery_guy_id) p.set("delivery_guy_id", params.delivery_guy_id);
    if (params.from) p.set("from", params.from); // dd-mm-yyyy
    if (params.to)   p.set("to",   params.to);
    return get(`/shift/${shiftId}/reportV3?${p}`);
};

export const getShiftEarningReport = async (shiftId, params) => {
    const p = new URLSearchParams();
    if (params.from) p.set("from", params.from);
    if (params.to)   p.set("to",   params.to);
    return get(`/shift/${shiftId}/earning-reportV2?${p}`);
};


export const getDeliveryGuysByShift = async (shiftId) => {
    return get(`/shift/${shiftId}/delivery-guys`);
}

export const updateActionOrderPrice = async (data) =>
    await post('/shift/action-order-price', data);


export const getGeneralSettings = async () =>
    await get('/setting/general-v2');

export const updateGeneralSettings = async (data) =>
    await post('/setting/general/update-v2', data);


export const getWhatsappTemplates = async (params = {}) =>
    await post("/setting/whatsapp-templates", { params });

export const getWhatsappTemplate = async (id) =>
    await get(`/setting/whatsapp-templates/${id}`);

export const createWhatsappTemplate = async (data) =>
    await post('/setting/whatsapp-templates/create', data);

export const updateWhatsappTemplate = async (id, data) =>
    await put(`/setting/whatsapp-templates/update/${id}`, data);

export const toggleWhatsappTemplate = async (id) =>
    await patch(`/setting/whatsapp-templates/${id}/toggle`);

export const deleteWhatsappTemplate = async (id) =>
    await del(`/setting/whatsapp-templates/delete/${id}`);

export const getActiveWhatsappTemplate = async (target = "CUSTOMER") =>
    await post("/setting/whatsapp-templates/active", {target});

export const sendManualWhatsappMsg = async (template_id, uniqueOrderId, reason=null) =>
    await post("/setting/whatsapp-templates/send-manual", {template_id, order_id: uniqueOrderId, reason })

export const getWhatsappOrderLogs = async (uniqueOrderId) =>
    await get(`/setting/whatsapp-templates/logs/${uniqueOrderId}`)

export const fetchTooLateWithoutNotes = async () =>
    await get('/analytics/too-late-without-notes');

export const fetchTooLateHistory = async (page = 1) =>
    await get(`/analytics/too-late-without-notes?tab=history&page=${page}`);

export const createDeliveryGuy = async (formData) =>
    post("/delivery-guy/register", formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });

export const updateDeliveryGuy = async (id, formData) => {
    // Laravel needs this for FormData PUT requests
    formData.append('_method', 'PUT');
    return post(`/delivery-guy/update/${id}`, formData);
};

export const addTodoNote = async (data) =>
    await post('/notes/add-note', data);


export const fetchCustomerFeedback = async ({
                                                page = 1,
                                                per_page = 10,
                                                search = "",
                                                from_date = "",
                                                to_date = "",
                                            } = {}) => {
    const params = new URLSearchParams({ page, per_page });

    if (search.trim())      params.set("search",    search.trim());
    if (from_date.trim())   params.set("from_date", from_date.trim());
    if (to_date.trim())     params.set("to_date",   to_date.trim());

    return get(`/customer-feedback?${params}`);
};


export const fetchCompletedFeedbacks = (params = {}) => {
    const query = new URLSearchParams();

    if (params.page) query.append("page", params.page);
    if (params.per_page) query.append("per_page", params.per_page);
    if (params.search) query.append("search", params.search);
    if (params.from_date) query.append("from_date", params.from_date);
    if (params.to_date) query.append("to_date", params.to_date);
    if (params.do_not_call_filter) query.append("do_not_call_filter", params.do_not_call_filter);

    if (params.is_attended !== undefined && params.is_attended !== "") {
        query.append("is_attended", params.is_attended);
    }

    if (params.source) query.append("source", params.source);
    if (params.target) query.append("target", params.target);
    if (params.priority) query.append("priority", params.priority);

    if (params.is_escalated !== undefined && params.is_escalated !== "") {
        query.append("is_escalated", params.is_escalated);
    }

    return get(`/customer-feedback/completed?${query.toString()}`);
};

export const storeCustomerFeedback = async (payload) =>
    await post("/customer-feedback/create", payload)


export const updateDeliveryGuyInactiveStatus = async (id, inactiveStatus) =>
    await put(`/delivery-guy/${id}/inactive-status`, {
            inactive_status: inactiveStatus,
        });


export const updateStoreInactiveStatus = async (id, inactiveStatus) =>
    await put(`/stores/${id}/inactive-status`, {
        inactive_status: inactiveStatus, // null = clear (active)
    });



export const fetchCoupons = ({ page = 1, per_page = 15 } = {}) =>
    get(`/coupons?page=${page}&per_page=${per_page}`);

export const fetchAllStoresForCoupons = () =>
    get('/coupons/stores');

export const fetchZones = () => get("/store/zones");

export const toggleStore = (id) => post(`/stores/${id}/toggle-active`);

export const toggleStorePromoted = (id) => post(`/stores/${id}/toggle-promoted`);

export const toggleStoreSchedule = (id) => post(`/stores/${id}/toggle-schedule`);

export const createCoupon = (data) => post("/coupons/create", data);

export const updateCoupon = (data) => post("/coupons/update", data);

export const deleteCoupon = (id) => del(`/coupons/${id}`);

export const searchPromoterUsers = async (q) => {
    const params = new URLSearchParams();
    if (q.trim()) {
        params.set("search", q.trim());
    }
    return get(`/coupons/promoter-users/search?${params.toString()}`);
}


export const fetchCouponStats = async (id, page, per_page) => {
    const params = new URLSearchParams({ page, per_page });
    return get(`/coupons/${id}/stats?${params.toString()}`);
}


export const fetchPromotionNotificationMeta = () =>
    get("/notification/meta");

export const searchPromotionNotificationUsers = (search = "") => {
    const params = new URLSearchParams();

    if (search.trim()) {
        params.set("search", search.trim());
    }

    return get(`/notification/users/search?${params.toString()}`);
};


export const fetchStoreCategories = () => get("/stores/categories");

export const sendPromotionNotification = (formData) =>
    apiClient
        .post("/notification/send", formData, {
            headers: {
                Accept: "application/json",
            },
        })
        .then((r) => r.data);


export const getAllDeliverySlots = async () =>
    get("/delivery-slots");

export const createDeliverySlot = async (request) =>
    post("/delivery-slots", request);

export const updateDeliverySlot = async (id, body) =>
    put(`/delivery-slots/${id}`, body);

export const deleteDeliverySlot = async (id) =>
    del(`/delivery-slots/${id}`);

export const toggleDeliverySlotActive = async (id) =>
    patch(`/delivery-slots/${id}/toggle-active`);

export const fetchDeliveryLocations = async () =>
    get("/delivery-locations");


export const fetchAllCarts = async ({
                                        page = 1,
                                        per_page = 15,
                                        restaurant_id,
                                        user_id,
                                    } = {}) => {
    const params = new URLSearchParams({ page, per_page });
    if (restaurant_id) params.set("restaurant_id", restaurant_id);
    if (user_id) params.set("user_id", user_id);
    return get(`user/carts?${params.toString()}`);
};



export const checkCartAddressLocation = async (cartId, {
                                            latitude,
                                            longitude
                                            }) => {
    return post(`/carts/${cartId}/quote-address`, {latitude, longitude});
}

export const placeOrderFromCart = (cartId, payload) =>
    post(`/carts/${cartId}/place-order`, payload);


export const fetchCustomerAddresses = (userId, restaurantId) => {
    const params = new URLSearchParams();

    if (restaurantId) params.set("restaurant_id", restaurantId);
    if (userId) params.set("user_id", userId);

    return get(`/user/customer-addresses?${params.toString()}`);
}



export const fetchHeroImages = () => get("/hero-images");

// formData must contain: heroimage (File), overlay_color, title (optional)
export const uploadHeroImage = (formData) =>
    post("/hero-images", formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });

export const updateHeroImage = (id, data) =>
    post(`/hero-images/${id}`, data); // { overlay_color, title }

// formData must contain: heroimage (File), overlay_color, title, _method: 'PUT'
export const replaceHeroImage = (id, formData) =>
    post(`/hero-images/${id}`, formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });

export const toggleHeroImageActive = (id) =>
    post(`/hero-images/${id}/activate`);

export const deleteHeroImage = (id) =>
    del(`/hero-images/${id}`);


export const searchLinkables = async (t, q, page) => {
    const params = new URLSearchParams({ page });

    if (q.trim())      params.set("q",    q.trim());
    params.set("type", t);

   return get(`/hero-images/linkables?${params.toString()}`);
}


// ---- Stats badge (top-level icon count, polled every 10s) ----
export const fetchSupportStats = () => get(`/dashboard-stats`);

// ---- Admin conversation list (left column, polled every 5s while panel open) ----
export const fetchAdminConversations = (status = null, page = 1) =>
    post(`/conversations`, { status, page });

// ---- Full message history for one conversation (loaded on open / cache-miss fallback) ----
export const fetchAdminMessages = (conversationId, perPage = 50) =>
    post(`/conversations/messages`, {
        conversation_id: conversationId,
        per_page: perPage,
    });

// ---- Cheap Redis-backed poll for new messages in the open conversation (every 5s) ----
export const pollAdminConversation = (conversationId, lastSeenMessageId = 0) =>
    post(`/conversations/poll`, {
        conversation_id: conversationId,
        last_seen_message_id: lastSeenMessageId,
    });

// ---- Admin sends a reply ----
export const sendAdminMessage = (conversationId, message) =>
    post(`/conversations/send-messages`, {
        conversation_id: conversationId,
        message,
    });

// ---- Admin closes a conversation ----
export const closeConversationByAdmin = (conversationId) =>
    post(`/conversations/close`, { conversation_id: conversationId });



export const fetchDeliveryAreas = ({ page = 1, per_page = 30, search = "" } = {}) => {
    const params = new URLSearchParams({ page, per_page });
    if (search.trim()) params.set("search", search.trim());
    return get(`/delivery-areas?${params.toString()}`);
};

export const fetchDeliveryArea = (id) => get(`/delivery-areas/${id}`);

export const createDeliveryArea = (data) => post("/delivery-areas", data);

export const updateDeliveryArea = (id, data) => put(`/delivery-areas/${id}`, data);

export const deleteDeliveryArea = (id) => del(`/delivery-areas/${id}`);

export const fetchStoresForDeliveryAreas = () => get("/delivery-areas/stores");

export const fetchAreasForStore = (storeId) => get(`/stores/${storeId}/delivery-areas`);

export const fetchStoresForArea = (areaId) => get(`/delivery-areas/${areaId}/stores`);

// payload: { id, delivery_areas: number[], stores_to_area?: boolean }
export const updateStoreAreaAssignment = (payload) =>
    post("/delivery-areas/update-store-area", payload);

export const getDeliveryAreaProSettings = () => get("/delivery-areas/settings");

export const saveDeliveryAreaProSettings = (data) => post("/delivery-areas/settings", data);


export const fetchCurrentVersion = () => get("/version");

export const fetchVersionStats = () => get("/version/stats");

export const forceUpdateVersion = (payload) =>
    post("/version/update", payload);


export const fetchUsersByVersionStatus = (status, page = 1, perPage = 20) =>
    get('/version/users', { status, page, per_page: perPage });
